import { render } from "./taller.vue?vue&type=template&id=006da941"
import script from "./taller.vue?vue&type=script&lang=js"
export * from "./taller.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__